import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=68593e62&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=js"
export * from "./contacts.vue?vue&type=script&lang=js"
import style0 from "./style/potential.scss?vue&type=style&index=0&id=68593e62&prod&lang=scss&scoped=true&external"
import style1 from "./contacts.vue?vue&type=style&index=1&id=68593e62&prod&lang=scss&scoped=true"
import style2 from "./contacts.vue?vue&type=style&index=2&id=68593e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68593e62",
  null
  
)

export default component.exports